import { TranslationType } from './TranslationContext';

export const fr: TranslationType = {
  header: {
    home: 'Accueil',
    about: 'À propos',
    services: 'Services',
    contact: 'Contact',
    language: 'Français',
    selectLanguage: 'Choisir la langue',
    scheduleConsultation: 'Planifier une consultation',
    allServices: 'Tous les services',
    monthlyBookkeeping: 'Comptabilité mensuelle numérique',
    taxPreparation: 'Services fiscaux aux entreprises',
    financialPlanning: 'Planification financière',
    businessConsulting: 'Accompagnement Stratégique'
  },
  hero: {
    tagline: "Bonjour! Nous sommes Algebra Solution Financières",
    title: {
      part1: '',
      highlight1: 'Solutions',
      part2: ' comptables expertes pour ',
      highlight2: 'votre entreprise'
    },
    description: 'Services comptables professionnels adaptés pour aider votre entreprise à se développer.',
    consultation: "Obtenez une consultation aujourd'hui, c'est gratuit!",
    contactUs: 'Contactez-nous'
  },
  about: {
    banner: {
      title: "Nous sommes là pour garantir votre succès",
      subtitle: "Nous nous consacrons à votre réussite, en fournissant des services comptables experts et des conseils pour vous aider à atteindre vos objectifs commerciaux.",
      chips: "À propos de nous"
    },
    story: {
      title: "Créé pour soutenir les entreprises en croissance depuis 2020",
      description: "Fondée en 2024, Algebra Solutions Financières rend les services comptables professionnels accessibles aux entreprises en croissance. Notre fondateur, Oussama Hentabli, CPA, apporte une expérience précieuse acquise au sein de cabinets Big 4, de petits cabinets comptables et de grandes entreprises. Cette expertise diversifiée nous permet d'accompagner efficacement les entreprises, en combinant la rigueur des grands cabinets avec l'approche personnalisée des services de boutique.",
      chips: "Notre histoire",
      button: "Prendre rendez-vous"
    },
    mission: {
      title: "Conseils financiers experts pour la croissance des entreprises.",
      description: "\"Notre mission est de donner aux entreprises des perspectives financières claires et des solutions comptables expertes, leur permettant de prendre des décisions en toute confiance et d'atteindre une croissance durable.\"",
      chips: "Notre mission",
      button: "Prendre rendez-vous"
    },
    values: {
      title: "Les valeurs qui nous façonnent",
      subtitle: "Nos valeurs de transparence, d'innovation et de centrage sur le client guident tout ce que nous faisons, garantissant un service exceptionnel et des partenariats durables.",
      chips: "Nos valeurs",
      value1: {
        title: "Excellence dans la prestation de services",
        description: "Nous fournissons des solutions comptables sur mesure avec précision et un accent sur le succès du client, garantissant que chaque interaction ajoute de la valeur."
      },
      value2: {
        title: "Communication transparente",
        description: "Nous valorisons une communication ouverte et claire. Tenir les clients informés renforce la confiance et assure des décisions éclairées."
      },
      value3: {
        title: "Innovation continue",
        description: "Nous adoptons de nouvelles idées et technologies. Notre accent sur l'innovation nous pousse à améliorer nos services et à proposer des solutions adaptées aux besoins de nos clients."
      },
      value4: {
        title: "Approche centrée sur le client",
        description: "Nous priorisons les besoins de nos clients, offrant des solutions personnalisées qui favorisent le succès et entretiennent des relations à long terme."
      }
    }
  },
  contact: {
    banner: {
      title: "Nous sommes là pour vous aider",
      subtitle: "Contactez-nous directement en utilisant les informations ci-dessous ou planifiez une réunion à l'aide de notre système de réservation en ligne.",
      chips: "Contactez-nous"
    },
    info: {
      title: "Entrez en contact avec nous!",
      subtitle: "Contactez directement notre équipe comptable ou utilisez notre outil de planification pratique pour réserver une consultation avec l'un de nos experts.",
      chips: "Contactez-nous",
      phone: {
        label: "Téléphone",
        value: "(514) 508-5552"
      },
      email: {
        label: "Adresse e-mail",
        value: "info@algebrasolution.ca"
      },
      location: {
        label: "Emplacement",
        value: "6500 Trans-Canada Hwy, Ste 400, Pointe-Claire, QC H9R 0A5"
      },
      hours: {
        label: "Heures d'ouverture",
        weekdays: "Lundi – Vendredi: 9h00 – 17h00",
        saturday: "Samedi: Sur rendez-vous",
        sunday: "Dimanche: Fermé"
      }
    },
    form: {
      title: "Planifier un rendez-vous"
    }
  },
  services: {
    banner: {
      title: "Vos finances, notre expertise",
      subtitle: "Découvrez notre gamme complète de services conçus pour aider votre entreprise à prospérer.",
      chips: "Nos services",
      button: "Planifier une consultation gratuite"
    },
    monthlyBookkeeping: {
      title: "Comptabilité mensuelle numérique",
      description: "Services de comptabilité complets pour garder vos finances organisées et à jour. Nous gérons les comptes fournisseurs, les comptes clients, les rapprochements et les états financiers mensuels.",
      chips: "Comptabilité mensuelle numérique",
      button: "Voir les détails",
      benefits: {
        title: "Avantages clés:",
        points: [
          "Précision des enregistrements en temps réel",
          "Économisez des heures chaque mois",
          "Rapports personnalisés"
        ]
      }
    },
    taxPreparation: {
      title: "Services fiscaux aux entreprises",
      description: "Services de préparation fiscale experts pour les entreprises et les particuliers. Nous assurons une déclaration précise tout en maximisant les déductions et crédits disponibles pour vous.",
      chips: "Services fiscaux aux entreprises",
      button: "Voir les détails",
      benefits: {
        title: "Avantages clés:",
        points: [
          "Maximiser les déductions",
          "Minimiser la charge fiscale",
          "À jour avec les dernières lois fiscales"
        ]
      }
    },
    financialPlanning: {
      title: "Planification financière",
      description: "Planification financière stratégique pour vous aider à atteindre vos objectifs commerciaux. Nous analysons votre position actuelle et développons des stratégies personnalisées pour la croissance.",
      chips: "Planification financière",
      button: "Voir les détails",
      benefits: {
        title: "Avantages clés:",
        points: [
          "Stratégies de croissance personnalisées",
          "Prévisions financières à long terme",
          "Conseils d'experts à chaque étape"
        ]
      }
    },
    businessConsulting: {
      title: "Accompagnement stratégique",
      description: "Conseils d'experts pour optimiser la stratégie et la croissance de votre entreprise. Nous vous aidons à prendre des décisions éclairées, à identifier des opportunités et à relever des défis en toute confiance.",
      chips: "Accompagnement stratégique",
      button: "Voir les détails",
      benefits: {
        title: "Avantages clés:",
        points: [
          "Feuilles de route stratégiques personnalisées",
          "Perspectives d'affaires par des experts",
          "Support décisionnel basé sur les données"
        ]
      }
    }
  },
  monthlyBookkeeping: {
    banner: {
      title: "Comptabilité mensuelle numérique",
      subtitle: "Gardez vos finances organisées et sans stress avec nos services de comptabilité complets. Nous gérons les chiffres pour que vous puissiez vous concentrer sur le développement de votre entreprise.",
      chips: "Nos services",
      button: "Planifier une consultation gratuite"
    },
    included: {
      title: "Ce qui est inclus",
      subtitle: "Notre service de comptabilité mensuelle numérique couvre tous les aspects critiques de vos opérations financières:",
      chips: "Ce qui est inclus",
      sections: {
        accountsPayable: {
          title: "Comptes fournisseurs et clients",
          description: "Nous suivons tous les paiements entrants et sortants, fournissons une facturation ponctuelle et assurons le suivi des comptes en retard pour maintenir un flux de trésorerie sain."
        },
        reconciliations: {
          title: "Rapprochements bancaires et de cartes de crédit",
          description: "Nous comparons vos registres internes avec les relevés bancaires pour identifier les écarts, détecter les erreurs ou fraudes rapidement, et garantir l'exactitude de vos données financières."
        },
        statements: {
          title: "États financiers mensuels",
          description: "Nous préparons des bilans, des comptes de résultat et des rapports de flux de trésorerie avec une analyse professionnelle pour vous aider à comprendre les tendances et à prendre des décisions éclairées."
        },
        categorization: {
          title: "Catégorisation des transactions",
          description: "Nous classifions chaque transaction selon les principes comptables et les besoins de votre entreprise, offrant des aperçus des habitudes de dépenses et des déductions fiscales potentielles."
        }
      }
    },
    benefits: {
      title: "Avantages clés",
      chips: "Avantages clés",
      sections: {
        time: {
          title: "Gagnez du temps",
          description: "Nous gérons toute la tenue de registres financiers pour que vous puissiez vous concentrer sur les initiatives stratégiques et les activités commerciales essentielles qui favorisent la croissance."
        },
        compliance: {
          title: "Restez conforme",
          description: "Notre approche méticuleuse garantit que votre entreprise reste conforme à toutes les exigences réglementaires, réduisant le stress et minimisant les pénalités potentielles."
        },
        visibility: {
          title: "Visibilité en temps réel",
          description: "Accédez à vos données financières via des systèmes sécurisés basés sur le cloud pour surveiller les flux de trésorerie, suivre les dépenses et prendre rapidement des décisions éclairées."
        }
      },
      button: "Planifier maintenant"
    },
    faq: {
      title: "Questions fréquemment posées",
      chips: "FAQ",
      questions: {
        data: {
          question: "Comment puis-je envoyer mes données financières?",
          answer: "Nous offrons un portail client sécurisé pour le téléchargement de documents, l'intégration directe avec votre logiciel comptable, ou un accès en lecture seule à vos comptes. Tous les transferts sont protégés par un cryptage de niveau entreprise."
        },
        system: {
          question: "Pouvez-vous travailler avec mon système existant?",
          answer: "Oui! Nous avons de l'expérience avec toutes les principales plateformes comptables, notamment QuickBooks, Xero, Sage et FreshBooks. Nous pouvons nous intégrer à votre système actuel ou vous aider à mettre en œuvre une nouvelle solution."
        },
        commitment: {
          question: "Dois-je m'engager à long terme?",
          answer: "Nous offrons des services flexibles de mois en mois sans exiger de contrats à long terme. Vous pouvez ajuster selon l'évolution des besoins de votre entreprise, bien que de nombreux clients continuent avec nous après avoir constaté les avantages."
        }
      }
    }
  },
  taxPreparation: {
    banner: {
      title: "Services fiscaux aux entreprises",
      subtitle: "Services fiscaux sans stress pour les entreprises et les particuliers. Nous gérons les détails pour que vous puissiez vous concentrer sur ce qui compte le plus.",
      chips: "Nos services",
      button: "Planifier une consultation gratuite"
    },
    included: {
      title: "Ce qui est inclus",
      subtitle: "Notre service de préparation fiscale couvre tous les aspects critiques de vos besoins en matière de déclaration fiscale:",
      chips: "Ce qui est inclus",
      sections: {
        returns: {
          title: "Déclarations fiscales pour entreprises et particuliers",
          description: "Préparation complète de toutes les déclarations fiscales requises pour votre entreprise et vos finances personnelles. Nous traitons les sociétés, les partenariats, les entreprises individuelles et les déclarations individuelles."
        },
        optimization: {
          title: "Optimisation des déductions et crédits",
          description: "Analyse stratégique de votre situation financière pour identifier toutes les déductions et crédits éligibles. Nous vous assurons de profiter de chaque opportunité d'économie fiscale disponible."
        },
        support: {
          title: "Soutien fiscal tout au long de l'année",
          description: "Assistance continue pour les questions fiscales et la planification tout au long de l'année, pas seulement pendant la saison fiscale. Nous fournissons des conseils proactifs sur les implications fiscales des décisions d'affaires."
        },
        documentation: {
          title: "Documentation prête pour l'audit",
          description: "Soyez préparé avec des dossiers correctement organisés et conformes. Nous vous aidons à maintenir une documentation complète qui répond aux exigences réglementaires et vous offre une tranquillité d'esprit."
        },
        financialStatements: {
          title: "Production d'états financiers (mission de compilation)",
          description: "Élaboration professionnelle d'états financiers dans le cadre d'une mission de compilation, conformes aux normes comptables applicables. Nous fournissons des rapports financiers fiables qui présentent clairement la situation financière de votre entreprise."
        }
      }
    },
    benefits: {
      title: "Avantages clés",
      chips: "Avantages clés",
      sections: {
        refunds: {
          title: "Maximisez vos remboursements",
          description: "Nous examinons votre situation financière complète pour découvrir les opportunités d'économies et vous assurer de recevoir chaque dollar auquel vous avez droit selon la loi fiscale."
        },
        mistakes: {
          title: "Évitez les erreurs coûteuses",
          description: "Nos experts restent à jour sur les lois fiscales pour que vous n'ayez pas à le faire. Nous vous aidons à naviguer dans les réglementations complexes et à prévenir les erreurs qui pourraient entraîner des pénalités ou des audits."
        },
        peace: {
          title: "Tranquillité d'esprit",
          description: "Avec tout géré professionnellement, vous pouvez vous sentir confiant pendant la période fiscale. Notre approche minutieuse assure la conformité tout en maximisant vos avantages financiers."
        }
      },
      button: "Planifier maintenant"
    },
    faq: {
      title: "Questions fréquemment posées",
      chips: "FAQ",
      questions: {
        behind: {
          question: "Pouvez-vous m'aider si j'ai du retard dans mes impôts?",
          answer: "Oui, nous aidons avec les déclarations en retard et la négociation des arrangements de paiement si nécessaire. Notre équipe a de l'expérience avec les clients qui doivent rattraper plusieurs années de déclarations fiscales."
        },
        selfEmployed: {
          question: "Travaillez-vous avec des travailleurs autonomes et des freelances?",
          answer: "Absolument! Nous sommes spécialisés dans l'aide aux professionnels indépendants pour naviguer dans leurs situations fiscales uniques, du suivi des dépenses professionnelles à la maximisation des déductions pour bureau à domicile."
        },
        documents: {
          question: "Quels documents dois-je fournir pour commencer?",
          answer: "Pour les déclarations personnelles: relevés de revenus, registres de dépenses et déclaration de l'année précédente. Clients commerciaux: états des profits/pertes, bilans et registres de paie. Nous fournirons une liste personnalisée lors de la consultation."
        }
      }
    }
  },
  financialPlanning: {
    banner: {
      title: "Planification financière",
      subtitle: "Conseils financiers stratégiques adaptés à vos objectifs commerciaux. Nous vous aidons à construire une feuille de route pour la croissance, la stabilité et le succès à long terme.",
      chips: "Nos services",
      button: "Planifier une consultation gratuite"
    },
    included: {
      title: "Ce qui est inclus",
      subtitle: "Notre service de planification financière couvre tous les aspects critiques de votre stratégie de croissance d'entreprise:",
      chips: "Ce qui est inclus",
      sections: {
        assessment: {
          title: "Évaluation financière actuelle",
          description: "Analyse complète de votre situation financière actuelle, y compris les actifs, les passifs, les modèles de flux de trésorerie et les indicateurs de rentabilité. Nous établissons une base claire pour mesurer les progrès."
        },
        strategy: {
          title: "Développement de stratégie orientée vers les objectifs",
          description: "Création collaborative de stratégies financières alignées sur vos objectifs commerciaux spécifiques. Nous traduisons votre vision en plans financiers concrets avec des jalons clairs."
        },
        cashFlow: {
          title: "Planification de trésorerie et de budget",
          description: "Développement de systèmes robustes de gestion de trésorerie et de budgets réalistes qui soutiennent vos opérations commerciales et vos plans de croissance. Nous vous aidons à anticiper les défis et à maintenir la stabilité."
        },
        growth: {
          title: "Planification de croissance et d'investissement",
          description: "Prenez des décisions éclairées concernant l'expansion, l'embauche et les investissements en capital. Notre analyse comprend des projections détaillées de ROI, des options de financement et une évaluation des risques."
        }
      }
    },
    benefits: {
      title: "Avantages clés",
      chips: "Avantages clés",
      sections: {
        decisions: {
          title: "Prenez des décisions éclairées",
          description: "Comprenez vos chiffres et ce qu'ils signifient pour la trajectoire de votre entreprise. Nos perspectives financières claires vous permettent de faire des choix stratégiques en toute confiance, basés sur des données plutôt que des suppositions."
        },
        growth: {
          title: "Réalisez une croissance durable",
          description: "Planifiez l'avenir avec des stratégies conçues pour soutenir la stabilité à long terme. Nous vous aidons à équilibrer des objectifs de croissance ambitieux avec une gestion financière prudente."
        },
        profitability: {
          title: "Maximisez la rentabilité",
          description: "Identifiez les domaines de réduction des coûts, d'amélioration des revenus et d'opportunités d'investissement. Notre approche aide à optimiser votre performance financière tout en maintenant la qualité."
        }
      },
      button: "Planifier maintenant"
    },
    faq: {
      title: "Questions fréquemment posées",
      chips: "FAQ",
      questions: {
        who: {
          question: "Pour qui la planification financière est-elle la plus adaptée?",
          answer: "Toute entreprise cherchant à croître stratégiquement, à améliorer les flux de trésorerie ou à se préparer à des changements majeurs. C'est particulièrement précieux pour les entreprises en croissance rapide, envisageant une expansion ou confrontées à des défis de trésorerie."
        },
        size: {
          question: "Dois-je avoir une grande entreprise?",
          answer: "Pas du tout. Nous travaillons avec des entreprises de toutes tailles, des entrepreneurs individuels aux sociétés établies. Les petites entreprises bénéficient souvent considérablement d'une planification financière professionnelle pour établir des bases solides."
        },
        implementation: {
          question: "M'aiderez-vous avec la mise en œuvre?",
          answer: "Absolument. Nous ne nous contentons pas de livrer un plan et de vous laisser vous débrouiller. Notre service comprend un soutien à la mise en œuvre, des examens réguliers des progrès et des ajustements si nécessaire."
        }
      }
    }
  },
businessConsulting: {
  banner: {
    title: "Accompagnement Stratégique",
    subtitle: "Conseils d'experts pour optimiser la stratégie et la croissance de votre entreprise. Que vous releviez des défis ou recherchiez de nouvelles opportunités, notre accompagnement stratégique vous aide à prendre des décisions éclairées en toute confiance.",
    chips: "Nos Services",
    button: "Planifier une Session Stratégique Gratuite"
  },
  included: {
    title: "Services Inclus",
    subtitle: "Nos services d'accompagnement stratégique sont conçus pour vous fournir des conseils d'experts à chaque étape du développement de votre entreprise — de la planification stratégique à l'exécution et l'évaluation.",
    chips: "Services Inclus",
    sections: {
      startup: {
        title: "Développement Stratégique",
        description: "Création collaborative de stratégies d'entreprise robustes alignées sur votre vision et les opportunités du marché. Nous vous aidons à établir des objectifs clairs et des plans d'action concrets."
      },
      financial: {
        title: "Analyse de Performance",
        description: "Évaluation approfondie de la performance de votre entreprise par rapport aux objectifs stratégiques. Nous identifions les domaines d'amélioration et recommandons des ajustements stratégiques pour optimiser les résultats."
      },
      cashFlow: {
        title: "Optimisation des Ressources",
        description: "Allocation stratégique des ressources de votre entreprise pour maximiser l'efficacité et soutenir la croissance. Nous développons des cadres pour garantir que vos investissements génèrent des rendements optimaux."
      },
      growth: {
        title: "Planification de Croissance et d'Innovation",
        description: "Approches prospectives du développement commercial et de l'innovation. Nous vous aidons à identifier de nouvelles opportunités et à créer des plans de mise en œuvre stratégiques."
      }
    }
  },
  benefits: {
    title: "Avantages Clés",
    chips: "Avantages Clés",
    sections: {
      experience: {
        title: "Expertise Stratégique",
        description: "Nous apportons une connaissance stratégique complète et des perspectives concrètes du monde des affaires. Nos conseillers offrent des points de vue précieux qui vous aident à naviguer dans des défis commerciaux complexes et à identifier des opportunités de croissance."
      },
      roadmaps: {
        title: "Approche Personnalisée",
        description: "Chaque entreprise a des besoins et des objectifs uniques — notre accompagnement stratégique est adapté spécifiquement à votre situation. Nous développons des stratégies personnalisées qui répondent à vos défis et objectifs spécifiques."
      },
      decisions: {
        title: "Prise de Décision Éclairée",
        description: "Prenez des décisions confiantes soutenues par une analyse approfondie et une réflexion stratégique. Nous fournissons des cadres et des perspectives clairs qui vous permettent de faire des choix alignés avec votre vision à long terme."
      }
    },
    button: "Planifier Maintenant"
  },
  faq: {
    title: "Questions Fréquemment Posées",
    chips: "FAQ",
    questions: {
      startup: {
        question: "Comment l'accompagnement stratégique peut-il bénéficier à mon entreprise?",
        answer: "L'accompagnement stratégique offre à votre entreprise des conseils d'experts pour prendre des décisions éclairées, identifier des opportunités de croissance, optimiser les opérations et développer des plans à long terme. Il vous aide à relever les défis et à positionner votre entreprise pour un succès durable."
      },
      industries: {
        question: "Pour quels types d'entreprises proposez-vous un accompagnement stratégique?",
        answer: "Nous offrons un accompagnement stratégique dans diverses industries, notamment la technologie, les services professionnels, le commerce de détail, la fabrication, la santé et bien d'autres. Notre expertise stratégique peut être appliquée aux entreprises de toutes tailles et à tous les stades de développement."
      },
      implementation: {
        question: "Aidez-vous à la mise en œuvre de la stratégie?",
        answer: "Oui, nous fournissons à la fois une planification stratégique et un soutien à la mise en œuvre. Nous croyons en la création de stratégies pratiques qui peuvent être exécutées efficacement, et nous vous accompagnons tout au long du processus de mise en œuvre pour garantir le succès."
      }
    }
  }
},
  servicesWeOffer: {
    title: 'Nos services',
    subtitle: 'Solutions comptables complètes pour aider votre entreprise à prospérer',
    services: {
      bookkeeping: {
        title: 'Comptabilité mensuelle numérique',
        description: 'Registres financiers précis et rapports ponctuels pour maintenir votre entreprise sur la bonne voie.'
      },
      taxPreparation: {
        title: 'Services fiscaux aux entreprises',
        description: 'Maximisez les déductions et assurez la conformité avec toutes les réglementations fiscales.'
      },
      financialPlanning: {
        title: 'Planification financière',
        description: 'Conseils stratégiques pour vous aider à atteindre vos objectifs commerciaux à court et à long terme.'
      },
      businessConsulting: {
        title: 'Accompagnement stratégique',
        description: 'Conseils personnalisés et accompagnement pour le développement stratégique de votre entreprise.'
      }
    },
    viewAll: 'Voir tous les services'
  },
  whatAlgebraCan: {
    benefits: 'Avantages',
    title: {
      part1: 'Ce que ',
      highlight: 'Algebra',
      part2: ' peut faire pour vous'
    },
    description: 'Algebra redéfinit l\'avenir de la banque et de la finance. Avec plusieurs années d\'expérience dans l\'industrie, nous combinons précision, innovation et service personnalisé pour offrir une clarté financière inégalée',
    points: {
      experience: 'Plusieurs années d\'expertise comptable',
      dedicated: 'Comptable personnel dédié pour chaque client',
      advanced: 'Solutions numériques avancées pour un service efficace'
    }
  },
  testimonials: {
    title: 'Ce que disent nos clients',
    subtitle: 'Écoutez les entreprises que nous avons aidées à réussir',
    testimonials: {
      client1: {
        quote: 'Algebra a transformé notre gestion financière. Leur expertise nous a aidés à réduire les coûts et à améliorer considérablement les flux de trésorerie.',
        name: 'Sarah Johnson',
        position: 'PDG, TechStart Inc.'
      },
      client2: {
        quote: 'L\'équipe d\'Algebra nous a fourni des conseils inestimables lors de notre expansion. Leur planification financière a fait toute la différence.',
        name: 'Michael Chen',
        position: 'Fondateur, GrowthPath Solutions'
      },
      client3: {
        quote: 'Travailler avec Algebra a changé la donne pour notre entreprise. Leur attention aux détails et leur approche proactive sont exceptionnelles.',
        name: 'Emily Rodriguez',
        position: 'Directrice, Innovative Retail Group'
      }
    }
  },
  footer: {
    reliable: {
      title: {
        part1: 'Fiable ',
        highlight1: 'Comptabilité',
        part2: ' Fiable.',
        highlight2: 'remarquables'
      },
      description: 'Des comptables personnels dédiés aux outils numériques avancés, Algebra offre une expérience comptable transparente fondée sur la confiance, la précision et la performance.',
      button: 'Planifier une consultation'
    },
    about: 'Nous fournissons des services comptables complets pour aider les entreprises à prendre des décisions financières éclairées et à atteindre leurs objectifs',
    services: {
      title: 'Services',
      taxPlanning: 'Services fiscaux aux entreprises',
      financialAnalysis: 'Analyse financière',
      bookkeepingServices: 'Services de comptabilité',
      businessConsulting: 'Accompagnement Stratégique',
      strategicSupport: 'Accompagnement stratégique'
    },
    company: {
      title: 'Entreprise',
      services: 'Services',
      aboutUs: 'À propos de nous',
      project: 'Projet',
      customer: 'Client'
    },
    contact: {
      title: 'CONTACT RAPIDE',
      contactUs: 'Contactez-nous',
      termsOfService: 'Conditions de service'
    },
    copyright: 'Copyright @ 2025 Algebra Solution Financière Tous droits réservés'
  }
};
